// ADR-133 D11: header stats for the Unmapped tab — the run the list comes from.
// Same HeaderStat blocks as Bench Candidates / Bench Data Entry Lag.
import React from 'react';
import { HeaderStats, HeaderStat } from '../../reports/BenchEntryLagReport/styles';

const UnmappedRunStrip = ({ unmapped }) => {
  const {
    data, titles, openCount, scopedRuns, newFromScopedCount, hasRun,
  } = unmapped;
  if (!data) {
    return null;
  }
  if (!hasRun) {
    return (
      <HeaderStats>
        <HeaderStat title="No complete real employees sync has been recorded yet">
          <div className="top">
            <span className="label">Last full run</span>
            <span className="value">Never</span>
          </div>
        </HeaderStat>
      </HeaderStats>
    );
  }
  return (
    <HeaderStats>
      <HeaderStat title="The latest complete real employees sync over the whole population">
        <div className="top">
          <span className="label">Last full run</span>
          <span className="value" style={{ fontSize: 16 }}>
            {data.runStartedAt ? new Date(data.runStartedAt).toLocaleString() : 'None yet'}
          </span>
        </div>
        <span className="sub">
          {data.mappingSetVersionUsed !== null ? `employees sync · mappings v${data.mappingSetVersionUsed}` : 'employees sync'}
        </span>
      </HeaderStat>
      {scopedRuns.length > 0 && (
        <HeaderStat title="Scoped runs since the last full run (e.g. bench candidate imports); their titles are listed too">
          <div className="top">
            <span className="label">Imports since</span>
            <span className="value">{scopedRuns.length}</span>
          </div>
          <span className="sub">{`${newFromScopedCount} new ${newFromScopedCount === 1 ? 'title' : 'titles'}`}</span>
        </HeaderStat>
      )}
      <HeaderStat title="Titles still needing attention: not mapped yet, or mapped before the run but still unresolved by it">
        <div className="top">
          <span className="label">Still unmapped</span>
          <span className="value" style={openCount > 0 ? { color: '#92400E' } : undefined}>{openCount}</span>
        </div>
        <span className="sub">{`of ${titles.length}`}</span>
      </HeaderStat>
    </HeaderStats>
  );
};

export default UnmappedRunStrip;
